import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Chatbot from './components/chatbot/Chatbot';
import Home from './pages/websitepages/Home';
import About from './pages/websitepages/About';
import Services from './pages/Services/Services';
import ArchitecturalDesign from './pages/Services/ArchitecturalDesign';
import Projects from './pages/websitepages/Projects';
import Contact from './pages/websitepages/Contact';
import Blog from './pages/Blogs/Blog';
import Residential from './pages/projects/Residential';
import BlogPost from './pages/Blogs/BlogPost'; 
import ConstructionCost from './pages/websitepages/ConstructionCost';
import CEOMessagePage from './pages/websitepages/CEOMessagePage';
import Commercial from './pages/projects/Commercial';
import Educational from './pages/projects/Educational';
import Religious from './pages/projects/Religious';
import Industrial from './pages/projects/Industrial';
import Infrastructure from './pages/projects/Infrastructure';
import Road from './pages/projects/Road';
import './styles/global.css';

// Simplified page transition
const pageTransition = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.3 }
};

// Main App Content Component
function AppContent() {
  const location = useLocation();
  
  // Define pages where footer should be shown
  const showFooterPages = ['/', '/contact','/ceo-message'];
  
  // Check if current path should show footer
  const shouldShowFooter = showFooterPages.includes(location.pathname);

  return (
    <div className="App">
      <Navbar />
      <main className="main-content">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route 
              path="/" 
              element={
                <motion.div {...pageTransition}>
                  <Home />
                </motion.div>
              } 
            />
            <Route 
              path="/about" 
              element={
                <motion.div {...pageTransition}>
                  <About />
                </motion.div>
              } 
            />
            <Route 
              path="/services" 
              element={
                <motion.div {...pageTransition}>
                  <Services />
                </motion.div>
              } 
            />
            <Route 
              path="/architectural-design" 
              element={
                <motion.div {...pageTransition}>
                  <ArchitecturalDesign />
                </motion.div>
              } 
            />
            <Route 
              path="/blog" 
              element={
                <motion.div {...pageTransition}>
                  <Blog />
                </motion.div>
              } 
            />
            <Route 
              path="/blog/:id" 
              element={
                <motion.div {...pageTransition}>
                  <BlogPost />
                </motion.div>
              } 
            />
            <Route 
              path="/construction-cost" 
              element={
                <motion.div {...pageTransition}>
                  <ConstructionCost />
                </motion.div>
              } 
            />
            <Route 
              path="/projects" 
              element={
                <motion.div {...pageTransition}>
                  <Projects />
                </motion.div>
              } 
            />
            <Route 
              path="/residential" 
              element={
                <motion.div {...pageTransition}>
                  <Residential/>
                </motion.div>
              } 
            />
            <Route 
              path="/commercial" 
              element={
                <motion.div {...pageTransition}>
                  <Commercial/>
                </motion.div>
              } 
            />
            <Route 
              path="/infrastructure" 
              element={
                <motion.div {...pageTransition}>
                  <Infrastructure/>
                </motion.div>
              } 
            />
            <Route 
              path="/industrial" 
              element={
                <motion.div {...pageTransition}>
                  <Industrial/>
                </motion.div>
              } 
            />
            <Route 
              path="/educational" 
              element={
                <motion.div {...pageTransition}>
                  <Educational/>
                </motion.div>
              } 
            />
            <Route 
              path="/religious" 
              element={
                <motion.div {...pageTransition}>
                  <Religious/>
                </motion.div>
              } 
            />
            <Route 
              path="/road" 
              element={
                <motion.div {...pageTransition}>
                  <Road/>
                </motion.div>
              } 
            />
            <Route 
              path="/ceo-message" 
              element={
                <motion.div {...pageTransition}>
                  <CEOMessagePage />
                </motion.div>
              } 
            />
            <Route 
              path="/contact" 
              element={
                <motion.div {...pageTransition}>
                  <Contact />
                </motion.div>
              } 
            />
          </Routes>
        </AnimatePresence>
      </main>
      
      {/* Conditionally render footer */}
      {shouldShowFooter && <Footer />}
      
      {/* Chatbot - This should NOT block your website content */}
      {/* <Chatbot /> */}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;